import React from "react";
import { NikoPatientInformationBarTemplate } from "themes/application/niko-patient/components";
import { NikoPatientInformationBarViewStore } from 'application/niko-patient/stores';
import { observer } from "mobx-react";
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new NikoPatientInformationBarViewStore(rootStore, componentProps), 'nikoPatientInformationBarViewStore')
@observer
class NikoPatientInformationBar extends React.Component {
	render() {
		return <NikoPatientInformationBarTemplate {...this.props} />;
	}
}

export default NikoPatientInformationBar;